import { UIChart } from 'primeng/chart';
import { Select } from 'primeng/select';
import { TabsModule } from 'primeng/tabs';
import { Timeline } from 'primeng/timeline';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DrawerModule } from 'primeng/drawer';
import { Paginator } from 'primeng/paginator';
import { RippleModule } from 'primeng/ripple';
import { providePrimeNG } from 'primeng/config';
import { DatePicker } from 'primeng/datepicker';
import { MultiSelect } from 'primeng/multiselect';
import { SelectButton } from 'primeng/selectbutton';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import {
  DialogService,
  DynamicDialogRef,
  DynamicDialogConfig,
  DynamicDialogModule,
} from 'primeng/dynamicdialog';

export {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogModule,
  DynamicDialogRef,
  providePrimeNG,
};

export const PRIMENG_MODULES = [
  ButtonModule,
  DatePicker,
  DialogModule,
  DrawerModule,
  DynamicDialogModule,
  FloatLabelModule,
  IconFieldModule,
  InputIconModule,
  InputTextModule,
  MultiSelect,
  Paginator,
  RippleModule,
  Select,
  SelectButton,
  TabsModule,
  Timeline,
  UIChart,
] as const;

export type PrimengModule = (typeof PRIMENG_MODULES)[number];
export type { PaginatorState } from 'primeng/types/paginator';
